// Api.
import api from '../Base';

// Types.
import HostDisk from '../../types/host/HostDisk';
import { showError } from '../../utils/showAlert';

const DiskApi = {

    // Disk volumes, optionally restricted to specific hosts. Sorted by name.
    getDisks: async (hostIds?: number[]): Promise<HostDisk[]> => {
        const idParams = hostIds && hostIds.length > 0
            ? '&' + hostIds.map(id => `hostid=${id}`).join('&')
            : '';
        const url = `disk?sort=name${idParams}`;

        let disks: HostDisk[] = [];

        await api.get<HostDisk[]>(url)
            .then((response) => {
                disks = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve disks.', error);
                showError('Failed to retrieve disks', error.message || error.toString());
            });

        return disks;
    },

    // Disk statistic metric types, including units and aggregation (same shape
    // as host/instance statistic types).
    getDiskStatisticTypes: async (): Promise<any[]> => {
        let types: any[] = [];

        await api.get<any[]>(`disk/statistic/type?collect=true`)
            .then((response) => {
                types = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve disk statistic types.', error);
                showError('Failed to retrieve disk statistic types', error.message || error.toString());
            });

        return types;
    },
};

export default DiskApi;
